import { Link as RemixLink } from "@remix-run/react";
import React from "react";
import { normalizeHref } from "../core";
import { useRootLoaderData } from "./useRootLoaderData";

type LinkProps = {
  children: React.ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

/**
 * normalize된 url로 이동합니다.
 *
 * @param {string} href - Valid한 URL로, `Link` 컴포넌트 내에서 normalize되어 이동됩니다.
 */
const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, ...attrs }, ref) => {
    const rootData = useRootLoaderData();

    const to = attrs.href
      ? normalizeHref(attrs.href, {
          origin: rootData.origin,
          region: rootData.region,
        })
      : "";

    return (
      <RemixLink to={to} prefetch="intent" {...attrs} ref={ref}>
        {children}
      </RemixLink>
    );
  },
);
Link.displayName = "Link";

export default Link;
